import { Placement } from '@popperjs/core'
import { useRouter } from 'next/router'
import { useContext, useState, useRef } from 'react'
import { usePopper } from 'react-popper'
import { useOnClickOutside } from 'usehooks-ts'

import { PrintShopContext } from '@lib/print/print-shop-context'
import { StringsContext } from '@lib/strings-context'

import Icon from '@components/icon'
import { getPageUrl, PageType } from '@lib/routes'

interface PrintShopMenuProps {
  placement?: Placement
  className?: string
}

const PrintShopMenu = ({
  className,
  placement = 'bottom-start',
}: PrintShopMenuProps) => {
  const strings = useContext(StringsContext)
  const { printShop, setPrintShop } = useContext(PrintShopContext)

  const router = useRouter()

  const ref = useRef<HTMLDivElement>(null)

  const [popperReferenceElement, setPopperReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [isOpen, setIsOpen] = useState(false)

  const popper = usePopper(popperReferenceElement, popperElement, {
    placement,
  })

  useOnClickOutside(ref, () => {
    setIsOpen(false)
  })

  const handleShopClick = () => {
    if (!printShop) {
      return
    }

    const printShopUrl = getPageUrl(PageType.PRIVATE_SHOP_PAGE, [
      printShop.slug,
    ])
    router.push(printShopUrl)
  }

  const handleLogoutClick = () => {
    setPrintShop(null)
    setIsOpen(false)
  }

  if (!printShop) {
    return null
  }

  return (
    <div ref={ref} className={className}>
      <button
        // @ts-expect-error https://popper.js.org/react-popper/v2/
        ref={setPopperReferenceElement}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
        className="flex items-center text-left gap-3"
      >
        <Icon name="Store" className="text-2xl" />

        <div>
          <p className="text-sm font-medium leading-4">{printShop.name}</p>
          <p className="text-xs italic leading-4">
            {printShop.institution?.name}
          </p>
        </div>

        <Icon name="ChevronDown" />
      </button>

      <div
        // @ts-expect-error https://popper.js.org/react-popper/v2/
        ref={setPopperElement}
        style={popper.styles.popper}
        {...popper.attributes.popper}
      >
        {isOpen && (
          <div className="my-3 bg-white text-black shadow">
            <button
              className="inline-flex items-center gap-3 w-full p-3 font-medium text-sm"
              onClick={handleShopClick}
            >
              <Icon name="Store" className="text-md" />

              <span>{strings.headerShopMenuShopLabel}</span>
            </button>
            <button
              className="inline-flex items-center gap-3 w-full p-3 font-medium text-sm"
              onClick={handleLogoutClick}
            >
              <Icon name="Logout" className="text-md" />

              <span>{strings.headerShopMenuLogoutLabel}</span>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default PrintShopMenu
